import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Box = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 16px;
  text-align: center;
  margin-top: 30px;

  div:first-child {
    padding-bottom: 8px;
  }
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #73217d;
  text-align: center;
`;

const LightText = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #000000;
  text-align: left;
  line-height: 1.5;
`;

const TermsConditions = ({ title, rule }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Title>{`${title} ${t("common.termsAndConditions")}`}</Title>
      <LightText dangerouslySetInnerHTML={{ __html: rule }} />
    </Box>
  );
};

export default TermsConditions;
